import { styled } from '@mui/material'

export const AppHeader = styled('header', { name: 'AppHeader' })({
  display: 'block',
  flex: '0 0 auto',
  zIndex: 25,
})
